import type { ColumnDef } from "../components/base-table-layout";
import type { EhrContextValue } from "../../shared-logic/ehr-context/ehr-context";
import type { EhrWritePath } from "../../../../domain/ehr";
import type { TableRow } from "../utils/tables-metadata";
import { EhrActionButton } from "./ehr-action-button";

export function createEhrWriteBackColumn<T extends TableRow>(
  ehrContext: EhrContextValue | undefined,
  path: EhrWritePath
): ColumnDef<T> | undefined {
  if (!ehrContext?.ehrDetails) return undefined;

  return {
    key: "ehrAction" as keyof T,
    header: ehrContext.ehrDetails.name,
    width: "120px",
    sortable: false,
    handleCellClick: (e: React.MouseEvent<HTMLTableCellElement>) => {
      e.stopPropagation();
    },
    render: (row: T) => {
      return <EhrActionButton row={row} path={path} />;
    },
  };
}
